import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import { api } from '../api/client';
import { AUTH_NOTE_KEY, useSession } from '../auth/session';
import { Field, FormError, useSubmit } from '../components/Field';
import { AuthCard } from '../components/Layout';

export function LoginPage() {
  const { signedIn, setup } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';
  const note = useQueryClient().getQueryData<string>(AUTH_NOTE_KEY);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const form = useSubmit(() => api.login({ username, password }), ({ user }) => {
    signedIn(user);
    void navigate(from, { replace: true });
  });
  return (
    <AuthCard title="Sign in">
      {note && <p role="status" className="success">{note}</p>}
      <form onSubmit={form.submit} noValidate>
        <Field label="Username" name="username" value={username} onChange={setUsername} autoComplete="username" error={form.fieldErrors.username} />
        <Field label="Password" name="password" type="password" value={password} onChange={setPassword} autoComplete="current-password" error={form.fieldErrors.password} />
        <FormError message={form.formError} />
        <button type="submit" disabled={form.pending}>Sign in</button>
      </form>
      {setup.signupOpen
        ? <p className="muted">No account yet? <Link to="/signup">Create one</Link></p>
        : <p className="muted">No account yet? Ask the owner for an invite link.</p>}
    </AuthCard>
  );
}
